const getForgotPasswordLink = (tenant) => {
  return '/password-recovery'
}

export default getForgotPasswordLink
